import angular from 'angular';

import SettingsComponent from './settings.cmpt';
import SceneModule from './scene';

export default angular
    .module('application.scene.authorized.scene.settings', [
        SceneModule.name
    ])
    .component(SettingsComponent.selector, SettingsComponent)
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($urlRouterProvider, $stateProvider, $transitionsProvider) {
    $urlRouterProvider.when('/settings', defaultRouteHandler);

    $stateProvider.state('authorized.calendar.settings', {
        url: '^/settings',
        component: SettingsComponent.selector,
        redirectTo: 'authorized.calendar.settings.general'
    });

    $transitionsProvider.onStart({
        to: 'authorized.calendar.settings.**'
    }, () => true);
}

/* @ngInject */
function defaultRouteHandler($injector) {
    const $state = $injector.get('$state');
    return $state.go('authorized.calendar.settings.general');
}



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/settings/index.js